import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Redirect /soccer/login and /soccer/register to site-level auth pages */
const SoccerAuthRedirect = ({ target }) => {
  const { search } = useLocation();
  return <Navigate to={`${target}${search}`} replace />;
};

export default SoccerAuthRedirect;
